/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { DeliveryOrder } from '../../models/delivery-order';
import { DeliveryOrderDetail } from '../../models/delivery-order-detail';

export interface AddDeliveryOrderDetailToDeliveryOrder$Params {
  uuid: string;
  
    /**
     * The delivery order detail to add
     */
    body: DeliveryOrderDetail
}

export function addDeliveryOrderDetailToDeliveryOrder(http: HttpClient, rootUrl: string, params: AddDeliveryOrderDetailToDeliveryOrder$Params, context?: HttpContext): Observable<StrictHttpResponse<DeliveryOrder>> {
  const rb = new RequestBuilder(rootUrl, addDeliveryOrderDetailToDeliveryOrder.PATH, 'post');
  if (params) {
    rb.path('uuid', params.uuid, {});
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<DeliveryOrder>;
    })
  );
}

addDeliveryOrderDetailToDeliveryOrder.PATH = '/delivery-orders/{uuid}/details';
